import React, {
  RefObject,
  useRef,
} from 'react';
import {
  InsuranceDTO,
} from 'dtos';
import Dialog from 'pages/Dashboard/components/Dialog';
import {
  useForm,
} from 'react-hook-form';
import isNil from 'lodash/isNil';
import Controller from 'core/components/FormController';
import InsuranceLookup from 'pages/Dashboard/components/InsuranceLookup';
import Button from 'pages/Dashboard/components/Button';
import {
  insurancesEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  Payer,
} from 'pages/Dashboard/types/insurance';

export type FixEligibilityDialogParams = {
  insurance: InsuranceDTO;
  patientId: number;
};

type Props = FixEligibilityDialogParams & {
  onClose: () => void;
};

type CorrectionForm = {
  insuranceName: string;
};

export default function FixEligibilityDialog({
  insurance,
  patientId,
  onClose,
}: Props) {
  const {
    handleSubmit,
    control,
  } = useForm<CorrectionForm>({ mode: 'onTouched' });

  const insuranceLookupRef = useRef<HTMLInputElement>(null);

  const onSubmit = async ({ insuranceName }: CorrectionForm) => {
    insurancesEventChannel.emit('onInsuranceCorrection', {
      ...insurance,
      insuranceName,
    }, patientId);
    onClose();
  };

  return (
    <Dialog
      open
      title="Update Insurance"
      onClose={onClose}
      onConfirm={() => {}}
      disableEscapeKeyDown
      disableBackdropClick
    >
      <div className="flex flex-1 flex-col w-full populate-form gap-form-row">
        <Controller
          name="insuranceName"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState: { error } }) => (
            <InsuranceLookup
              {...field}
              onChange={(value: Payer) => { field.onChange(value?.payerName); }}
              error={!isNil(error)}
              id="insurance-name"
              className="space-y-1"
              inputRef={insuranceLookupRef as RefObject<HTMLInputElement>}
            />
          )}
        />
      </div>
      <div className="flex justify-end items-center gap-2">
        <Button
          variant="outlined"
          type="button"
          onClick={onClose}
        >
          Close
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          onClick={handleSubmit(onSubmit)}
        >
          Update
        </Button>
      </div>
    </Dialog>
  );
}
